import { render } from "./Food-edit.vue?vue&type=template&id=88c74b82&scoped=true"
import script from "./Food-edit.vue?vue&type=script&lang=js"
export * from "./Food-edit.vue?vue&type=script&lang=js"

import "./Food-edit.vue?vue&type=style&index=0&id=88c74b82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c74b82"]])

export default __exports__